// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  text: 'Concluir',
  label: 'Finalize a configuração e feche este formulário',
} as ILanguage;
